import { render, staticRenderFns } from "./UpgradeModal.vue?vue&type=template&id=12138e96&scoped=true"
import script from "./UpgradeModal.vue?vue&type=script&lang=js"
export * from "./UpgradeModal.vue?vue&type=script&lang=js"
import style0 from "./UpgradeModal.vue?vue&type=style&index=0&id=12138e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12138e96",
  null
  
)

export default component.exports